import React, { useEffect, useState } from "react";
import "./index.css";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import BannerDeslgadoDesktop from "../../assets/images/pngs/LandPage_Leo80Plus_AmigoLeo.jpg";
import BannerDeslgadoMobile from "../../assets/images/pngs/LandPage_Leo80Plus_AmigoLeo.jpg";



export default function Novidades() {
  return (
    <>
      <div className="d-flex justify-content-center">
        <img
          className="desktopDeslogado"
          width={"60%"}
          src={BannerDeslgadoDesktop}
          alt="Banner Desktop"
        />
        <img
          className="mobileDeslogado"
          width={"60%"}
          src={BannerDeslgadoMobile}
          alt="Banner Mobile"
        />
      </div>
    </>
  );
}
